{
    "SortAsc1Label": "1ère ascendante",
    "SortDsc1Label": "1er Descendant",
    "SortAsc2Label": "2ème Ascendant",
    "SortDsc2Label": "2ème descente",
    "SortAsc3Label": "3ème Ascendant",
    "SortDsc3Label": "3ème Descendant",
    "SortNoneLabel": "[Non trié par]",
    "SortAsc1Tooltip": "Trie principalement les lignes du rapport en ordre croissant selon la statistique\/le champ sélectionné.",
    "SortDsc1Tooltip": "Trie principalement les lignes du rapport en descendant par la statistique\/le champ sélectionné.",
    "SortAsc2Tooltip": "Deuxièmement, trier en ordre croissant par la statistique\/le champ sélectionné.",
    "SortDsc2Tooltip": "Deuxièmement, trier en descendant par la statistique\/le champ sélectionné.",
    "SortAsc3Tooltip": "Trier les lignes du rapport en troisième position par ordre croissant selon la statistique\/le champ sélectionné.",
    "SortDsc3Tooltip": "Trier les lignes du rapport en troisième position descendante par la statistique\/le champ sélectionné.",
    "SortNoneTooltip": "Ne pas trier les lignes du rapport par la statistique\/le champ sélectionné.",
    "NAME": "SortList"
}